<template>
  <v-container class="fill-height h-screen">
    <v-row no-gutters justify="center" align="center">
      <v-col cols="12" sm="5" md="6" class="pr-3">
        <v-img
          :src="NotFoundImage"
          aspect-ratio="1"
          :cover="true"
          max-width="469"
          max-height="345"
        />
      </v-col>
      <v-col cols="12" sm="7" md="6" class="sz-primary-grey--text pl-3 mt-3 mt-sm-0">
        <p class="text-h3 font-weight-medium mb-3">
          {{ $t('notFound.title') }}
        </p>
        <p class="f-20 font-weight-regular">
          {{ $t('notFound.text') }}
        </p>
        <v-row no-gutters>
          <v-col cols="12" lg="6">
            <BaseButton href="https://szlachetnapaczka.pl" target="_self" class="mr-4">
              {{ $t('notFound.szpButton') }}
            </BaseButton>
          </v-col>
          <v-col cols="12" lg="6" class="mt-3 mt-lg-0">
            <BaseButton
              id="swr-404-family"
              :to="{ name: ROUTE_NAMES.HOME, query: { action: 'wybor_rodziny', place: '404' } }"
              variant="secondary"
            >
              {{ $t('notFound.returnToFamiliesList') }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseButton from '@/components/widgets/BaseButton.vue'
import ROUTE_NAMES from '@/constants/routeNames'
import NotFoundImage from '@/assets/images/404.png'

export default {
  name: 'NotFound',
  components: { BaseButton },
  data() {
    return {
      ROUTE_NAMES,
      NotFoundImage
    }
  }
}
</script>
